export type BioProcessImageType = 'DOCUMENT_FRONT' | 'DOCUMENT_BACK' | `SELFIE_${string}`;

export interface BioProcessInitRequest {
  type: 'DOCUMENT';
  captchaToken?: string;
}

export interface BioProcessImageStep {
  image_id: string;
  image_type: BioProcessImageType;
  label: string;
}

export interface BioProcessStep {
  step_name?: string;
  images: BioProcessImageStep[];
  max_retry: number;
  order: number;
}

export interface BioSelfieCapture {
  imageId: string;
  imageType: BioProcessImageType;
  label: string;
  file: File;
}

/** Respuesta de init-process modelada según el contrato Mock Server biométrico. */
export interface BioProcessInitResponse {
  requestId: string;
  allowed_content_types: string[];
  expiration_process: number;
  steps: BioProcessStep[];
}

export interface BioPresignedFileRequest {
  fileName: string;
  image_type: BioProcessImageType;
  contentType: string;
  md5: string;
}

export interface BioPresignedUrlRequest {
  requestId: string;
  files: BioPresignedFileRequest[];
  captchaToken?: string;
}

export interface BioPresignedUrlEntry {
  image_type: BioProcessImageType;
  expiresIn: number;
  url: string;
}

export interface BioPresignedUrlResponse {
  requestId: string;
  presignedUrls: BioPresignedUrlEntry[];
}

export interface BioValidateRequest {
  requestId: string;
}

export type BioProcessStatus = 'complete' | 'failed' | 'finish_ok' | 'finish_fail' | 'retry';

export interface BioValidateResponse {
  requestId: string;
  status: BioProcessStatus | string;
  score: number;
  scoringAllowed: number;
  failureReason: string | null;
  captchaRequired: boolean;
  customerBiometricId: number | null;
}

export const BIO_CUSTOMER_BIOMETRIC_SESSION_KEY = 'bio_customer_biometric';

export interface BioCustomerBiometricSession {
  requestId: string;
  customerBiometricId: number;
}

export interface BioApiErrorBody {
  error?: string;
  code?: string;
  message: string;
}
